import * as actions from '~/search2/actions';
import _ from 'lodash';

const defaultState = {
  filters: { query: '' },
  query: '',
  isFiltering: false,
  isRequestingResults: false,
  contents: [],
  metadata: {},
  ranFirstQuery: false,
  dateOpt: {},
  severityVal: [0, 10], //Default range for severity
  isSearchMode: true,
  cvss: 'cvss3',
};

const searchDataState = (state = defaultState, action) => {
  switch (action.type) {
    case actions.SELECT_SEARCH_DATA_FILTERS:
      return action.searchFilters;
    case actions.SET_SEARCH_DATA_FILTER:
      return Object.assign({}, state, { filters: action.newFilters });
    case actions.REQUEST_SEARCH_DATA_RESULT:
      return Object.assign({}, state, action);
    case actions.REQUEST_SEARCH_DATA_FILTER:
      return Object.assign({}, state, action);
    case actions.RECEIVE_SEARCH_DATA_RESULT: {
      const oldContent = _.cloneDeep(state['contents']);
      let newContent = action.contents;
      const newMetaData = action.metadata;

      if (oldContent && action.concat) {
        newContent = [...oldContent, ...newContent];
      }

      return {
        ...state,
        ...action,
        contents: newContent,
        metadata: newMetaData,
      };
    }
    case actions.SEARCH_DATA_BE_ERROR:
      return Object.assign({}, state, action);
    case actions.UPDATE_DATE_OPT:
      return {
        ...state,
        dateOpt: {
          ...state.dateOpt,
          [action.key]: action.val,
        },
      };
    case actions.UPDATE_SEVERITY_VAL:
      return {
        ...state,
        severityVal: action.val,
      };
    case actions.UPDATE_IS_SEARCH_MODE:
      return {
        ...state,
        isSearchMode: action.isSearchMode,
      };
    case actions.UPDATE_CVSS_SELECTION:
      return {
        ...state,
        cvss: action.cvss,
      };
    default:
      return state;
  }
};

export default searchDataState;
